/* Shared with Shopify. Isolated from commerce. Click, touch and keyboard supported. */
(()=>{'use strict';
 function init(root){
  if(root.dataset.sceneReady)return;root.dataset.sceneReady='true';
  const tabs=[...root.querySelectorAll('[data-scene-tab]')];
  const panels=[...root.querySelectorAll('[data-scene-panel]')];
  function activate(index,focus=false){
   tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});
   panels.forEach((panel,i)=>{panel.hidden=i!==index;panel.classList.toggle('is-active',i===index);});
   root.querySelector('[data-scene-count]').textContent=String(index+1).padStart(2,'0');
   if(focus)tabs[index].focus({preventScroll:true});
   const strip=tabs[index].parentElement;const a=tabs[index].getBoundingClientRect(),b=strip.getBoundingClientRect();if(a.left<b.left)strip.scrollLeft-=b.left-a.left+4;else if(a.right>b.right)strip.scrollLeft+=a.right-b.right+4;
  }
  tabs.forEach((tab,i)=>{
   tab.addEventListener('click',()=>activate(i));
   tab.addEventListener('keydown',event=>{
    let next;if(event.key==='ArrowRight')next=(i+1)%tabs.length;if(event.key==='ArrowLeft')next=(i-1+tabs.length)%tabs.length;
    if(event.key==='Home')next=0;if(event.key==='End')next=tabs.length-1;
    if(next!==undefined){event.preventDefault();activate(next,true);}
   });
  });
  panels.forEach(panel=>{
   const pins=[...panel.querySelectorAll('[data-gear-button]')],cards=[...panel.querySelectorAll('[data-gear-card]')];
   pins.forEach((pin,i)=>pin.addEventListener('click',()=>{
    pins.forEach((item,n)=>item.setAttribute('aria-pressed',String(n===i)));
    cards.forEach((card,n)=>card.hidden=n!==i);
   }));
  });
  activate(0);
 }
 document.querySelectorAll('[data-scene-shop]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-scene-shop]').forEach(init));
 document.addEventListener('shopify:block:select',event=>{
  const panel=event.target.closest('[data-scene-panel]');
  if(panel){const root=panel.closest('[data-scene-shop]');root.querySelector(`[aria-controls="${panel.id}"]`)?.click();}
 });
})();
